import MappingItem, { componentName } from './MappingItem';

customElements.define(componentName, MappingItem);
